<script lang="ts">
    import ROUTE_IDS from '$src/generated/routeIds';
    import { page } from '$app/stores';
    import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
    import { getRoute } from '$src/lib/services/navigation';
    import { onMount } from 'svelte';
    import { GATEKEEPER_VERSION } from '$src/lib/services/gatekeeper';

    onMount(() => {
        const externalSubscribe = spineBus.subscribe('external', async (payload) => {
            if (payload.kind === 'session-ended') {
                await window.fabric
                    .getGatekeeper(GATEKEEPER_VERSION as 'v2.2.9', 'fabric-spine-v2')
                    .auth.logOut();

                spineBus.publish('player', {
                    kind: 'logged-out',
                    id: $page.data.sessionId!
                });

                window.location.href = getRoute(ROUTE_IDS.HOME) ?? '/';
            }
        });

        return () => {
            externalSubscribe();
        };
    });
</script>
